<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard-layout
          ref="formWizard"
          @showHideLoading="showHideLoading"
          @on-validated="onStepValidated"
          @on-complete="storeUpdate"
          :tabsContent="tabsContent"
          v-if="this.isCreate() || this.isUpdate()"
        >
          <template slot="dataConfirm">
            <step-confirm :infoData="model" ref="stepConfirm" />
          </template>
        </form-wizard-layout>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import { resetObjectProperties } from 'src/util/Util.js';
import FirstStep from 'src/views/Pages/Dashboard/Sigatoka/Config/steps/FirstStep.vue';
import SecondStep from 'src/views/Pages/Dashboard/Sigatoka/Config/steps/SecondStep.vue';
import StepConfirm from 'src/views/Pages/Dashboard/Sigatoka/Config/steps/StepConfirm.vue';
import MixinMenu from 'src/util/mixinMenu';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import FormWizard from 'src/components/Layouts/FormWizard.vue';

export default {
  components: {
    [FormWizard.name]: FormWizard,
    FirstStep,
    SecondStep,
    StepConfirm,
  },
  mixins: [MixinPermissions, MixinMenu, MixinLoading, MixinAlert],
  data() {
    return {
      model: {},
    };
  },
  computed: {
    tabsContent() {
      const tabs = [
        {
          title: i18n.t('common_words.general_information'),
          reference: 'firstStep',
          component: FirstStep,
        },
      ];
      if (this.model.canConfigBW)
        tabs.push({
          title: i18n.t('sigatoka.bw_config'),
          reference: 'secondStep',
          component: SecondStep,
        });

      return tabs;
    },
    getModuleRoute() {
      return 'sigatoka/config';
    },
  },
  methods: {
    onStepValidated(dataModel) {
      this.model = { ...this.model, ...dataModel };
    },
    cleanAllSteps() {
      this.$refs.formWizard.$refs.firstStep[0].model = {
        ...resetObjectProperties({
          ...this.$refs.formWizard.$refs.firstStep[0].model,
        }),
        canConfigBW: false,
        hasYoungPlants: false,
        changeLabel: false,
        infectionPicture: false,
      };
      this.$refs.formWizard.$refs.secondStep[0].model = {
        ...resetObjectProperties({
          ...this.$refs.formWizard.$refs.secondStep[0].model,
        }),
        leaf_count: 3,
        leafs: [
          {
            number: 1,
            status: [null],
            plus: [null],
            minus: [null],
          },
          {
            number: 2,
            status: [null],
            plus: [null],
            minus: [null],
          },
          {
            number: 3,
            status: [null],
            plus: [null],
            minus: [null],
          },
        ],
      };
      this.model = {
        ...resetObjectProperties(this.model),
      };
    },
    alertResponse(response) {
      SweetAlert.continue(
        response.data.message ? response.data.message : response.errors
      ).then((result) => {
        if (result.value) {
          try {
            this.$refs.formWizard.$refs.wizard.reset();
          } catch (error) {}
          this.cleanAllSteps();
          sessionStorage.removeItem('editForm');
        } else if (result.dismiss) {
          this.$router.push('/' + this.getModuleRoute);
        }

        return result;
      });
    },
    storeUpdate() {
      this.showHideLoading(true);
      this.model.route = this.getModuleRoute;
      if (sessionStorage.getItem('editForm') && this.isUpdate()) {
        if (this.isUpdate()) {
          this.model.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              this.alertResponse(response);
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate())
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              this.alertResponse(response);
            })
            .catch((error) => this.showMessageErrors(error));
        else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },
  mounted() {
    this.selectedItemOnMenu('sigatoka');
    this.showHideLoading(true);
    setTimeout(() => {
      this.showHideLoading();
    }, 5000);
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
    this.deselectedItemOnMenu('sigatoka');
  },
};
</script>
